module.exports = __webpack_public_path__ + "img/Estado.77e9d3ea.png";